<script>
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();
  export let show = false;
  export let title;

  function popupClosed() {
    dispatch("closed", {});
  }

  function handleKeydown(event) {
    if (event.key === "Escape") {
      popupClosed();
    }
  }
</script>

<svelte:window on:keydown={handleKeydown} />

<div class="popup {show ? 'show' : 'hidden'}">
  <div class="dark-bg" on:click={popupClosed} />
  <div class="p-10 content bg-gray-50 rounded-3xl">
    <div class="header">
      {#if title !== undefined}
        <h4 class="">{title}</h4>
      {/if}
    </div>
    <slot />
  </div>
</div>

<style type="text/scss">
  .popup {
    position: absolute;
    left: 0;
    top: 0;
    display: grid;
    width: 100vw;
    height: 100vh;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    grid-template-areas: "popup";
    justify-items: center;
    align-items: center;
    transition: all 400ms;
    margin: 0;
    padding: 0;

    &.show {
      z-index: 1000;
      opacity: 1;
    }

    &.hidden {
      opacity: 0;
      z-index: -1;
    }

    .dark-bg {
      background: rgba(0, 0, 0, 1);
      width: 100vw;
      height: 100vh;
      opacity: 0.5;
      z-index: 90;
      grid-area: popup;
    }

    .content {
      grid-area: popup;
      z-index: 100;
    }
  }
</style>
